webpackJsonp([2],{

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Information_vue__ = __webpack_require__(387);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3875f4c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Information_vue__ = __webpack_require__(441);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Information_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3875f4c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Information_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profile-left-nav',
  methods: {
    logout: function logout() {
      if (process.browser) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.confirm({
          title: 'Warning',
          content: 'Logout?',
          type: 'orange',
          useBootstrap: false,
          buttons: {
            tryAgain: {
              text: 'OK',
              action: function action() {
                _this.$store.dispatch('profileLogin/logout').then(function () {
                  _this.$router.push(_this.RouterConfig.Home);
                });
              }
            },
            close: function close() {}
          }
        });
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftNavigator_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e78f8bde_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeftNavigator_vue__ = __webpack_require__(240);
function injectStyle (ssrContext) {
  __webpack_require__(238)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e78f8bde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeftNavigator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e78f8bde_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeftNavigator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(239);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(217)("1107436e", content, true, {});

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(216)(true);
// imports


// module
exports.push([module.i, ".fc-profile-left-nav[data-v-e78f8bde]{list-style:none;padding:0;border-right:1px solid #d1d2d4;width:150px;height:300px}.fc-profile-left-nav>li>a[data-v-e78f8bde]{font-size:11px;font-weight:700;letter-spacing:.5px;color:#111;padding:10px 0;display:block;cursor:pointer;text-decoration:none}.fc-profile-left-nav>li>a[data-v-e78f8bde]:before{font-family:Ionicons;font-size:14px;color:#009938;margin-right:10px}.fc-profile-left-nav>li>a.fc-order[data-v-e78f8bde]:before{content:\"\\F143\"}.fc-profile-left-nav>li>a.fc-credit[data-v-e78f8bde]:before{content:\"\\F205\"}.fc-profile-left-nav>li>a.fc-address[data-v-e78f8bde]:before{content:\"\\F448\"}.fc-profile-left-nav>li>a.fc-logout[data-v-e78f8bde]:before{content:\"\\F1B2\"}", "", {"version":3,"sources":["D:/Forecepts_SVN_Project/SubwaySpecs/trunk/UI/WebUI/src/components/profile/LeftNavigator.vue"],"names":[],"mappings":"AACA,sCACE,gBAAiB,AACjB,UAAW,AACX,+BAAgC,AAChC,YAAa,AACb,YAAc,CACf,AACD,2CACE,eAAgB,AAChB,gBAAkB,AAClB,oBAAsB,AACtB,WAAe,AACf,eAAgB,AAChB,cAAe,AACf,eAAgB,AAChB,oBAAsB,CACvB,AACD,kDACE,qBAAwB,AACxB,eAAgB,AAChB,cAAe,AACf,iBAAmB,CACpB,AACD,2DACE,eAAiB,CAClB,AACD,4DACE,eAAiB,CAClB,AACD,6DACE,eAAiB,CAClB,AACD,4DACE,eAAiB,CAClB","file":"LeftNavigator.vue","sourcesContent":["\n.fc-profile-left-nav[data-v-e78f8bde] {\n  list-style: none;\n  padding: 0;\n  border-right: 1px solid #d1d2d4;\n  width: 150px;\n  height: 300px;\n}\n.fc-profile-left-nav > li > a[data-v-e78f8bde] {\n  font-size: 11px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  color: #111111;\n  padding: 10px 0;\n  display: block;\n  cursor: pointer;\n  text-decoration: none;\n}\n.fc-profile-left-nav > li > a[data-v-e78f8bde]::before {\n  font-family: 'Ionicons';\n  font-size: 14px;\n  color: #009938;\n  margin-right: 10px;\n}\n.fc-profile-left-nav > li > a.fc-order[data-v-e78f8bde]::before {\n  content: \"\\f143\";\n}\n.fc-profile-left-nav > li > a.fc-credit[data-v-e78f8bde]::before {\n  content: \"\\f205\";\n}\n.fc-profile-left-nav > li > a.fc-address[data-v-e78f8bde]::before {\n  content: \"\\f448\";\n}\n.fc-profile-left-nav > li > a.fc-logout[data-v-e78f8bde]::before {\n  content: \"\\f1b2\";\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"fc-profile-left-nav"},[_c('li',[_c('router-link',{staticClass:"fc-order",attrs:{"to":("" + (this.RouterConfig.MyOrders))}},[_vm._v("\n\t\t\t\tMY ORDERS\n\t\t\t")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"fc-credit",attrs:{"to":("" + (this.RouterConfig.MyCredit))}},[_vm._v("\n\t\t\t\tMY CREDIT\n\t\t\t")])],1),_vm._v(" "),_c('li',[_c('router-link',{staticClass:"fc-address",attrs:{"to":("" + (this.RouterConfig.MyInformation))}},[_vm._v("\n\t\t\t\tMY INFORMATION\n\t\t\t")])],1),_vm._v(" "),_c('li',[_c('a',{staticClass:"fc-logout",on:{"click":_vm.logout}},[_vm._v("Logout")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_profile_LeftNavigator__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_profile_Info__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_profile_EditDetail__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_profile_ChangePassword__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_profile_EditAddress__ = __webpack_require__(439);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MyOrders',
  components: {
    'left-nav': __WEBPACK_IMPORTED_MODULE_2__components_profile_LeftNavigator__["a" /* default */],
    'info': __WEBPACK_IMPORTED_MODULE_3__components_profile_Info__["a" /* default */],
    'editdetail': __WEBPACK_IMPORTED_MODULE_4__components_profile_EditDetail__["a" /* default */],
    'change-password': __WEBPACK_IMPORTED_MODULE_5__components_profile_ChangePassword__["a" /* default */],
    'edit-address': __WEBPACK_IMPORTED_MODULE_6__components_profile_EditAddress__["a" /* default */]
  },
  data: function data() {
    return {
      editingDetail: false,
      changeingPassword: false,
      editingAddress: false,
      editingAddressId: 0
    };
  },
  created: function created() {
    this.$store.dispatch('customer/getCustomerInfo');
  },

  methods: {
    editAddress: function editAddress(id) {
      this.editingAddressId = id;
      this.editingAddress = true;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('customer', ['info']))
});

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_map_fields__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProfileInfo',
  created: function created() {
    this.$store.dispatch('customer/getAddressList');
  },

  methods: {
    editDetail: function editDetail() {
      this.$emit('editDetail');
    },
    changePassword: function changePassword() {
      this.$emit('changePassword');
    },

    editAddress: function editAddress(address) {
      this.$emit('editAddress', address);
    },
    deleteAddress: function deleteAddress(id) {
      var _this = this;
      var d = {
        CustomersAddressId: id
      };
      if (process.browser) {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default.a.confirm({
          title: 'Warning',
          content: 'Remove this address?',
          type: 'orange',
          useBootstrap: false,
          buttons: {
            tryAgain: {
              text: 'OK',
              action: function action() {
                _this.$store.dispatch('customer/removeAddress', d);
              }
            },
            close: function close() {}
          }
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('customer', ['info']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex_map_fields__["c" /* mapMultiRowFields */])('customer', {
    addressList: 'addressList'
  }), {
    defaultAddress: function defaultAddress() {
      return this.addressList.filter(function (a) {
        return a.IsDefault;
      })[0];
    },
    additionAddress: function additionAddress() {
      return this.addressList.filter(function (a) {
        return a.IsDefault === false;
      });
    }
  })
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(35);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editprofile',
  data: function data() {
    return {
      account: {
        FullName: '',
        Email: '',
        ContacctNo: ''
      }
    };
  },
  created: function created() {
    this.account = {
      FullName: this.info.FullName,
      Email: this.info.Email,
      ContacctNo: this.info.ContacctNo
    };
  },

  methods: {
    editCustomer: function editCustomer() {
      var _this = this;

      var profile = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.account));
      this.$store.dispatch('customer/editCustomerInfo', profile).then(function (a) {
        _this.$emit('closeEditDetail');
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])('customer', ['info']))
});

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editpassword',
  created: function created() {
    this.password = {
      RecentPassword: '',
      NewPassword: '',
      ConfirmedPassword: ''
    };
  },

  methods: {
    editCustomer: function editCustomer() {
      var _this = this;

      if (process.browser) {
        if (this.password.RecentPassword === '' || this.password.NewPassword === '' || this.password.ConfirmedPassword === '') {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.alert({
            title: 'Notice',
            content: 'Please input your password',
            type: 'orange',
            useBootstrap: false
          });
          return;
        }
        if (this.password.NewPassword !== this.password.ConfirmedPassword) {
          __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.alert({
            title: 'Notice',
            content: 'New password not equal to confirmed password',
            type: 'orange',
            useBootstrap: false
          });
          return;
        }
      }
      var profile = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.password));
      this.$store.dispatch('customer/editCustomerPassword', profile).then(function (a) {
        _this.$emit('closeEditDetail');
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'edit-address',
  data: function data() {
    return {
      address: {}
    };
  },

  props: ['keyId'],
  created: function created() {
    this.address = {
      Address: this.keyId.Address,
      BuildingName: this.keyId.BuildingName,
      CustomersAddressId: this.keyId.CustomersAddressId,
      FullName: this.keyId.FullName,
      IsDefault: this.keyId.IsDefault,
      MobileNo: this.keyId.MobileNo,
      PostalCode: this.keyId.PostalCode,
      UnitNo: this.keyId.UnitNo
    };
  },

  methods: {
    updateAddress: function updateAddress() {
      var _this = this;

      if (this.address.PostalCode.length !== 6) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.alert({
          title: 'Notice',
          content: 'Invalid postal code',
          type: 'red',
          useBootstrap: false
        });
        return;
      }
      this.$store.dispatch('customer/editAddress', this.address).then(function () {
        _this.$emit('close');
      });
    },

    getAddress: function getAddress() {
      var _this2 = this;

      if (this.address.PostalCode.length !== 6) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.alert({
          title: 'Notice',
          content: 'Invalid postal code',
          type: 'red',
          useBootstrap: false
        });
        return;
      }
      this.$store.dispatch('address/getAddress', this.address.PostalCode).then(function (a) {
        if (a !== null) {
          _this2.findAddress = true;
          _this2.address.Address = a.BLK_NO + ' ' + a.ROAD_NAME + ' ' + a.BUILDING;
        } else {
          _this2.findAddress = false;
          _this2.address.Address = '';
        }
      });
    }
  }
});

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Info_vue__ = __webpack_require__(388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3379510_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Info_vue__ = __webpack_require__(434);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3379510_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc-account-info"},[_c('label',[_vm._v("My Information")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"fc-account-detail"},[_c('label',[_vm._v("Account Details")]),_vm._v(" "),_c('div',[_c('label',[_vm._v("FULL NAME")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.info.FullName))])]),_vm._v(" "),_c('div',[_c('label',[_vm._v("EMAIL ADDRESS")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.info.Email))])]),_vm._v(" "),_c('div',[_c('label',[_vm._v("MOBILE NO.")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.info.ContacctNo))])]),_vm._v(" "),_c('div',{staticClass:"fc-control"},[_c('a',{on:{"click":_vm.editDetail}},[_vm._v("Edit my details")]),_vm._v(" "),_c('a',{on:{"click":_vm.changePassword}},[_vm._v("Change password")])])]),_vm._v(" "),_c('div',{staticClass:"fc-address-list"},[(_vm.defaultAddress != null)?_c('div',{staticClass:"fc-default-address"},[_c('label',[_vm._v("Default Address")]),_vm._v(" "),_c('div',[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.defaultAddress.FullName)),_c('br'),_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.defaultAddress.MobileNo)),_c('br'),_c('br'),_vm._v("\n\n\t\t\t\t\t"+_vm._s(_vm.defaultAddress.Address)),_c('br'),_vm._v("\n\t\t\t\t\t#"+_vm._s(_vm.defaultAddress.UnitNo)),_c('br'),_vm._v("\n\t\t\t\t\tSingapore "+_vm._s(_vm.defaultAddress.PostalCode)+"\n\t\t\t\t")]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.editAddress(_vm.defaultAddress)}}},[_vm._v("Edit")])]):_vm._e(),_vm._v(" "),(_vm.additionAddress.length > 0)?_c('div',{staticClass:"fc-address-item"},[_c('label',[_vm._v("Additional Address")]),_vm._v(" "),_vm._l((_vm.additionAddress),function(add){return _c('div',{staticClass:"fc-address"},[_c('div',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(add.FullName)),_c('br'),_vm._v("\n\t\t\t\t\t\t"+_vm._s(add.MobileNo)),_c('br'),_c('br'),_vm._v("\n\n\t\t\t\t\t\t"+_vm._s(add.Address)),_c('br'),_vm._v("\n\t\t\t\t\t\t#"+_vm._s(add.UnitNo)),_c('br'),_vm._v("\n\t\t\t\t\t\tSingapore "+_vm._s(add.PostalCode)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"fc-control"},[_c('a',{on:{"click":function($event){return _vm.editAddress(add)}}},[_vm._v("Edit")]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.deleteAddress(add.CustomersAddressId)}}},[_vm._v("Delete")])])])})],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditDetail_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b79a693_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditDetail_vue__ = __webpack_require__(436);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b79a693_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc-edit-detail"},[_c('label',[_vm._v("Edit Details")]),_vm._v(" "),_c('form',[_c('div',[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.FullName),expression:"account.FullName"}],attrs:{"type":"text"},domProps:{"value":(_vm.account.FullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "FullName", $event.target.value)}}})]),_vm._v(" "),_c('div',[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.Email),expression:"account.Email"}],attrs:{"type":"text"},domProps:{"value":(_vm.account.Email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "Email", $event.target.value)}}})]),_vm._v(" "),_c('div',[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.ContacctNo),expression:"account.ContacctNo"}],attrs:{"type":"text"},domProps:{"value":(_vm.account.ContacctNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "ContacctNo", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('a',{on:{"click":_vm.editCustomer}},[_vm._v("UPDATE DETAILS")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',[_vm._v("*")]),_vm._v("FULL NAME")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',[_vm._v("*")]),_vm._v("EMAIL")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',[_vm._v("*")]),_vm._v("MOBILE NO.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67bdffd1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__ = __webpack_require__(438);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67bdffd1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc-edit-detail"},[_c('label',[_vm._v("Change Password")]),_vm._v(" "),_c('form',[_c('div',[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.RecentPassword),expression:"password.RecentPassword"}],attrs:{"type":"text"},domProps:{"value":(_vm.password.RecentPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "RecentPassword", $event.target.value)}}})]),_vm._v(" "),_c('div',[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.NewPassword),expression:"password.NewPassword"}],attrs:{"type":"text"},domProps:{"value":(_vm.password.NewPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "NewPassword", $event.target.value)}}})]),_vm._v(" "),_c('div',[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password.ConfirmedPassword),expression:"password.ConfirmedPassword"}],attrs:{"type":"text"},domProps:{"value":(_vm.password.ConfirmedPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.password, "ConfirmedPassword", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('a',{on:{"click":_vm.editCustomer}},[_vm._v("CHANGE PASSWORD")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',[_vm._v("*")]),_vm._v("RECENT PASSWORD")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',[_vm._v("*")]),_vm._v("NEW PASSWORD")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',[_vm._v("*")]),_vm._v("CONFIRM NEW PASSWORD")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditAddress_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d90976_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditAddress_vue__ = __webpack_require__(440);
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditAddress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78d90976_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditAddress_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fc-edit-detail fc-edit-address"},[_c('label',[_vm._v("Edit Address")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"fc-column"},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.FullName),expression:"address.FullName"}],attrs:{"type":"text"},domProps:{"value":(_vm.address.FullName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "FullName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"fc-column"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.MobileNo),expression:"address.MobileNo"}],attrs:{"type":"text"},domProps:{"value":(_vm.address.MobileNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "MobileNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"fc-column"},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.PostalCode),expression:"address.PostalCode"}],attrs:{"minlength":"6","maxlength":"6","type":"text"},domProps:{"value":(_vm.address.PostalCode)},on:{"blur":_vm.getAddress,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "PostalCode", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"fc-column"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.UnitNo),expression:"address.UnitNo"}],attrs:{"type":"text"},domProps:{"value":(_vm.address.UnitNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "UnitNo", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('label',[_vm._v("ADDRESS")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.Address),expression:"address.Address"}],attrs:{"placeholder":!_vm.findAddress ? 'Please fill in manually' : '',"type":"text"},domProps:{"value":(_vm.address.Address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "Address", $event.target.value)}}})]),_vm._v(" "),_c('div',[_c('label',[_vm._v("BUILDING NAME")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.BuildingName),expression:"address.BuildingName"}],attrs:{"type":"text"},domProps:{"value":(_vm.address.BuildingName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "BuildingName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"fc-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.IsDefault),expression:"address.IsDefault"}],attrs:{"value":"true","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.address.IsDefault)?_vm._i(_vm.address.IsDefault,"true")>-1:(_vm.address.IsDefault)},on:{"change":function($event){var $$a=_vm.address.IsDefault,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="true",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.address, "IsDefault", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.address, "IsDefault", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.address, "IsDefault", $$c)}}}}),_vm._v(" "),_c('label',[_vm._v("Make default delivery address")])]),_vm._v(" "),_c('div',[_c('a',{on:{"click":_vm.updateAddress}},[_vm._v("UPDATE ADDRESS")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',[_vm._v("*")]),_vm._v("FULL NAME")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',[_vm._v("*")]),_vm._v("MOBILE NO.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',[_vm._v("*")]),_vm._v("POSTAL CODE")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',[_vm._v("*")]),_vm._v("UNIT NO.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui fluid container fc-myinfo"},[_c('div',{staticClass:"fc-banner"},[_c('div',{staticClass:"ui container"},[_c('div',{staticClass:"fc-crumbs"},[_c('router-link',{attrs:{"to":("" + (this.RouterConfig.Home))}},[_vm._v("Home")]),_vm._v("\n\t\t\t\t>\n\t\t\t\t"),_c('span',[_vm._v("Account Profile")])],1),_vm._v(" "),(_vm.info != null && _vm.info != undefined)?_c('div',{staticClass:"fc-title"},[_vm._v("\n\t\t\t\tHi, "+_vm._s(_vm.info.FullName)+"\n\t\t\t")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"ui container fc-content"},[_c('div',[_c('left-nav')],1),_vm._v(" "),_c('div',{staticClass:"fc-content-right"},[(!_vm.editingDetail && !_vm.changeingPassword && !_vm.editingAddress)?_c('info',{on:{"editDetail":function($event){_vm.editingDetail = true},"changePassword":function($event){_vm.changeingPassword = true},"editAddress":_vm.editAddress}}):_vm._e(),_vm._v(" "),(_vm.editingDetail)?_c('editdetail',{on:{"closeEditDetail":function($event){_vm.editingDetail = false}}}):_vm._e(),_vm._v(" "),(_vm.changeingPassword)?_c('change-password',{on:{"closeEditDetail":function($event){_vm.changeingPassword = false}}}):_vm._e(),_vm._v(" "),(_vm.editingAddress)?_c('edit-address',{attrs:{"keyId":_vm.editingAddressId},on:{"close":function($event){_vm.editingAddress = false}}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.js?v=1698631571653